import axios from "axios";
import { count } from "firebase/firestore";
import { useEffect, useState } from "react";
import NotPaid from "../../../utilities/not-paid";
import Cookies from "js-cookie";
import NotUser from "../../../utilities/not-user";

const Payment = () => {

    const [existingCompanies, setExistingCompanies] = useState([]);
    const [targetCompany, setCompany] = useState('');
    const [status, setStatus] = useState('')

    const test_company_link = "http://localhost:3000/companies/"
    const production_company_link = "https://apple-tree-server.vercel.app/companies/"

    const test_payment_link = "http://localhost:3000/payment/"
    const production_payment_link = "https://apple-tree-server.vercel.app/payment/"

    
    const getCompanies = async () => {
        await axios.get(production_company_link)
        .then(response => {
            console.log(response)
            setExistingCompanies(response.data);
        })
        .catch(error => console.log(error))
    }

    const updatePayment = async () => {
        const company_id = targetCompany.id;
        await axios.post(production_payment_link, {
            company_id,
            status
        })
        .then((response) => {
            alert('Status changed successfully!')
            window.location.reload();
        })
        .catch((error) => {
            console.warn(error);
        })
    }

    let count = 0;

    useEffect(() => {
        getCompanies();
    }, []);

    useEffect(() => {
        if (
            document.getElementById('status-change') != null
        ) {
            if (status == "Paid") {
                document.getElementById('status-change').classList.add('text-success')
            } else {
                document.getElementById('status-change').classList.remove('text-success')
            }
        }
            
        
        
    }, [status]);

    const company = Cookies.get(`token_company`);
    const email = Cookies.get(`token_email`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);
    const phone = Cookies.get(`token_phone`);


    if (!firstname || !lastname || !company || !email || !phone) {
        return (
                <NotUser/>
        )
    }

    const statusNow = Cookies.get(`token_status`);

    if (statusNow != 'Paid') {
        return (
            <NotPaid/>
        )
    }


    return ( 
        <div>
            <h1 className="text-center text-muted display-5">Payments</h1>
            


<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel">Update {targetCompany.name}</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Change status of <span className="fw-light">{targetCompany.name}</span>  to <span id="status-change" style={{
            color:"OrangeRed"
        }}>{status}</span> 
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" onClick={() => {
            updatePayment();
        }}>Confirm</button>
      </div>
    </div>
  </div>
</div>
            <div className="m-4">
                <table class="table table-bordered table-striped table-hover borded rounded-3 overflow-hidden m-3">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Registered User</th>
                        <th scope="col">Company</th>
                        <th scope="col">Status</th>
                    </tr>
                </thead>
                <tbody>
                    { 
                        existingCompanies.length > 0 &&
                        existingCompanies.map((company) => {
                            count += 1;
                            console.log(company.status);
                            let statusColor = '';
                            
                            if (company.status == 'Paid') {
                                statusColor = 'text-success'
                            } else {
                                statusColor = ''
                            }
                            

                            return (
                                <tr data-bs-toggle="modal" data-bs-target="#exampleModal" onClick={() => {
                                    setCompany(company)
                                    if (company.status == 'Unpaid') {
                                        setStatus('Paid')
                                    } else {
                                        setStatus('Unpaid')
                                    }
                                }}>
                                    <th>{count}</th>
                                    <td>{company.registered_user}</td>
                                    <td>{company.name}</td>
                                    <td className={statusColor} id="status" style={{
                                        color:"OrangeRed"
                                    }}>{company.status}</td>
                                </tr>
                            )
                        })
                    }
                    {/* <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="" style={{
                            color:"OrangeRed"
                        }}>Unpaid</td>

                    </tr>
                    <tr>
                        <th>1</th>
                        <td>Lebang Nong</td>
                        <td>SalvationTees</td>
                        <td className="text-success">Paid</td>

                    </tr> */}
                </tbody>
            </table> 
            </div>
           
            
        </div>
     );
}
 
export default Payment;